// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".char-width__wrapper[data-v-d569cfe4]{position:absolute;visibility:hidden;top:0;left:0}.char-width__wrapper .char-width__char[data-v-d569cfe4]{font-size:13px;line-height:17px;display:inline-block;white-space:pre}", ""]);
// Exports
module.exports = exports;
